import tenantData from '@data';
import store from '@store';

const defaultDataForWidget = {
  ksa: [
    {
      id: 14,
      name: 'Normal Listing',
    },
    {
      id: 15,
      name: 'Hot Listing',
    },
    {
      id: 16,
      name: 'Super Hot Listing',
    },
    {
      id: 17,
      name: 'Credit',
    },
    {
      id: 18,
      name: 'Photography Service',
    },
    {
      id: 19,
      name: 'Videography Service',
    },
    {
      id: 39,
      name: 'Refresh Listing',
    },
  ],
};

const getDataSetsForCredits = (data, platform) => {
  let productData;
  productData = data?.map((e) => {
    return {
      ...e,
      dataSet: [e?.used, e?.available],
      ...tenantData.products?.find((it) => it?.id == 17), //as only credit
      name: defaultDataForWidget?.[platform]?.find((item) => item?.id == 17)?.name,
    };
  });
  return productData;
};

const widgetMapper = (platform, productsByPlatform) => {
  return {
    key: platform?.slug,
    platform,
    title: 'Credits Balance',
    cardTitle: 'Credits',
    assignToLink: '/agency-staff',
    buyMoreLink: '/prop-shop',
    products: getDataSetsForCredits([productsByPlatform?.[platform?.slug]], platform?.slug),
    current_package_details: productsByPlatform?.current_package,
    labels: [
      {
        label: 'Available',
        icon: 'NotOpen',
        type: 'primary',
        slug: 'available',
      },
      {
        label: 'Used',
        icon: 'Opened',
        type: 'success',
        slug: 'used',
      },
    ],
    links: [
      {
        link: '/credits-usage',
        link_title: 'About Bayut Credits',
      },
    ],
    colors: ['#9299B8', tenantData.platformList.find((item) => item.slug === platform?.slug).brandColor],
  };
};

export const creditsWidgetMapper = (response, combineCredits = false) => {
  const user = store.getState().app.loginUser.user;
  const quotaCredits = {};
  const { platformList } = tenantData;

  if (combineCredits) {
    const combinedCredits = {};
    const defaultPlatform = platformList?.[0];

    platformList.forEach((platform) => {
      const platformCredits = response?.credits_summary?.[platform?.slug];
      if (platformCredits) {
        Object.entries(platformCredits).forEach(([key, value]) => {
          if (typeof value === 'number') {
            combinedCredits[key] = (combinedCredits[key] || 0) + value;
          } else if (!combinedCredits[key]) {
            combinedCredits[key] = value;
          }
        });
      }
    });

    const clubbedData = {
      bayut: combinedCredits,
      current_package: { ...response?.credits_summary?.current_package },
    };

    quotaCredits[defaultPlatform.slug] = widgetMapper(defaultPlatform, clubbedData);
  } else {
    platformList.forEach((platform) => {
      const platformSlug = platform?.slug;

      if (user?.isCurrencyUser) {
        quotaCredits[platformSlug] = widgetMapper(platform, response?.credits_summary);
      } else if (response?.data?.[platformSlug]) {
        quotaCredits[platformSlug] = widgetMapper(platform, response?.credits_summary?.[platformSlug]);
      }
    });
  }

  return quotaCredits;
};

const quotaCreditsDataMapper = (values, combineCredits) => {
  const quotaCredits = {};
  tenantData.platformList.forEach((e) => {
    quotaCredits[e.slug] = creditsWidgetMapper(e, values?.credits_summary, combineCredits);
  });

  return quotaCredits;
};

const customCreditsPriceDataMapper = (values) => {
  return { price: values?.net_price, nonDiscountedPrice: values?.price };
};

export const manageTransferQuotaCreditsTransformer = (user) => {
  const loggedInUser = store.getState().app.loginUser.user;
  const data = {};

  tenantData.platformList.forEach((platform) => {
    let { quota = {}, credits = [] } = user?.[platform?.slug];
    //removed video and photo credits bcz no need to show these credits in transfer quota screen right now
    credits = credits?.length ? credits?.filter((e) => e.id !== 13 && e.id !== 14) : [];
    credits.unshift(quota);
    const platformProducts = [];
    tenantData.products?.forEach(
      (e) =>
        credits?.find((it) => it?.id === e?.id) &&
        platformProducts.push({ ...e, ...credits?.find((it) => it?.id === e?.id) }),
    );
    data[platform.slug] = {
      title: loggedInUser?.is_shifted_to_olx_quota ? 'Quota and Credits' : 'Listings and Credits',
      icon: platform.icon,
      zones: { all: platformProducts },
      platformText: platform?.title,
    };
  });
  return data;
};

export default {
  creditsWidgetMapper,
  quotaCreditsDataMapper,
  customCreditsPriceDataMapper,
  manageTransferQuotaCreditsTransformer,
};
